/* eslint-disable complexity */
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { Formik, Form } from 'formik';
import {
  validationSchema,
  validationSchemaAdditionalDataOTP,
  validationSchemaCause
} from './PortalIDCheckValidation';
import { withStyles } from '@material-ui/core/styles';
import OutlinedTextField from '../../shared/Fields/OutlinedTextField';
import SegmentHeader from '../../shared/SegmentHeader';
import StepperButtons from '../../shared/StepperButtons';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import InfoField from '../../shared/InfoField';
import Dialog from '@material-ui/core/Dialog';
import PrimaryButton from '../../shared/Buttons/PrimaryButton';
import _get from 'lodash/get';
import OutlinedSelectChippedInput from '../../shared/Inputs/OutlinedSelectChipped';
import FormItemContainer from '../../shared/Containers/FormItemContainer';
import CustomDialog from '../../shared/Modals/CustomDialog';
import Timer from "../../shared/Timer";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import OTPValidationProcess from './OTPModal';
import { Fade, Typography } from '@material-ui/core';
import { doctypes, ValidationMethodOptions, ValidationMethodTypes } from '../../../constants/enums';
import toCamelCase from 'lodash/camelCase';
import _lowerFirst from 'lodash/lowerFirst';
import _upperFirst from 'lodash/upperFirst';
import OTPTransunionModal from './OTPTransunionModal';

class PortalIDCheck extends PureComponent {
  RESEND_FLAG_SECONDS_DELAY = 120;
  timer = null;

  currentStep = this.props.routes.indexOf(this.props.location.pathname);
  nextStep = this.currentStep + 1;

  state = {
    externalTabOpened: false,
    biometric_identification: null,
    value1: 1,
    value2: 1,
    value3: 1,
    value4: 1,
    biometricValidationFailedTimes: 0,
    securityForm: false,
    securityQuestions: false,
    cause: '',
    observation: '',
    scrollUp: false,
    dataNeeded: false,
    biometricFailModal: false,
    noTriesRemaining: false,
    showOtpValidationModal: false,
    email: '',
    mobile: '',
    showAniUnavailableModal: false,
    isSubmittingMobile: false,
    isSelectedFacialBiometric: false,
    isSelectedFingerprintBiometric: false,
    isSelectedSecurityQuestions: false,
    questionModal: false,
    // Timer
    counter: 0,
    canResend: false,
    firstCounter: true,
    selectedMethod: '',
    mobileToValidate: null,
    emailToValidate: null,
    questions: [],
    xmlDoc: null,
  };

  componentDidMount() {
    const { isSecureSale, isBiometricValidationInSecureSaleActive, validationMethod } = this.props;
    const mandatoryBiometricValidation = isSecureSale && isBiometricValidationInSecureSaleActive;
    this.props.setCurrentStep(this.currentStep);
    this.props.toggleIDModal(false);
    this.props.resetBiometricProps(false);
    this.props.resetOTPCodeProp();

    const isSelectedFacialBiometric = Boolean(ValidationMethodOptions.find(vm => vm.id === validationMethod && vm.name === ValidationMethodTypes.FacialBiometric));
    const isSelectedFingerprintBiometric = Boolean(ValidationMethodOptions.find(vm => vm.id === validationMethod && vm.name === ValidationMethodTypes.FingerprintBiometric));
    const isSelectedSecurityQuestions = Boolean(ValidationMethodOptions.find(vm => vm.id === validationMethod && vm.name === ValidationMethodTypes.SecurityQuestions));

    this.setState({
      isSelectedFacialBiometric,
      isSelectedFingerprintBiometric,
      isSelectedSecurityQuestions,
      isSubmittingMobile: isSelectedFacialBiometric
    });

    if (!this.props.validateAniInSales) {
      this.setState({ showAniUnavailableModal: true });
      return;
    }

    const currentPOS =
      this.props.pointOfSales &&
      this.props.pointOfSales.find(i => i.id == this.props.pointOfSale);
    if (
      (!this._isTraditionalSale() || !this.ignoreBiometricValidation()) &&
      (currentPOS && isSelectedSecurityQuestions) && !mandatoryBiometricValidation) {
      this.setState({ dataNeeded: true }, () => {
        if (currentPOS.attributes.hasFingerprintBiometric || currentPOS.attributes.hasFacialBiometric) {
          this.setState({ questionModal: true });
        }
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.props.validateAniInSales) return;

    if (this.state.counter <= 0) {
      clearInterval(this.timer);
      this.timer = null;
      this.setState({ canResend: true });
    }
    if (this.props.open && this.state.firstCounter) {
      this.resetResendFlag();
      this.setState({ firstCounter: false });
    }

    if (this.props.causal !== prevProps.causal) {
      if (this.props.causal === true) {
        this.setState({ cause: '', observation: '', dataNeeded: true });
        this._handleClose();
      }
    }

    const mandatoryBiometricValidation = this.props.isSecureSale && this.props.isBiometricValidationInSecureSaleActive;
    if (
      this.props.debtorQuestions.securityQuestions !==
      prevProps.debtorQuestions.securityQuestions ||
      this.props.cosignerQuestions.securityQuestions !==
      prevProps.cosignerQuestions.securityQuestions
    ) {
      this.setState({ securityForm: true });
      this.setState({ securityQuestions: true });
    }
    if (
      this.props.biometricValidationFailedTimes !==
      prevProps.biometricValidationFailedTimes
    ) {
      this.setState({
        biometricValidationFailedTimes: this.props
          .biometricValidationFailedTimes
      });
      if (this.props.biometricValidationFailedTimes === 5) {
        this.setState({ biometricFailModal: true, noTriesRemaining: true });
      }
    }
    if (this.state.scrollUp) {
      this.setState({ scrollUp: false });
    }
    if (this.props.currentClient !== prevProps.currentClient) {
      if (this.props.currentClient == 'cosigner') {
        this.setState({ dataNeeded: true });
      }
      this.setState({ scrollUp: true });
      this.props.resetScrollProp();
    }

    if (this.props.questionsFailed) {
      this.props.resetProp({ causal: false, questionsFailed: false });
      this.setState({ securityForm: false, securityQuestions: false, cause: '', dataNeeded: true });
    }

    if (this.props.retry && !mandatoryBiometricValidation) {
      this.props.resetRetryProp();
      this.setState({ dataNeeded: true });
    }

    // OTP
    this.handleOTPCodes(prevProps);

    if (this.props.examData !== prevProps.examData) {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(this.props.examData, 'application/xml');

      const questionsNodes = Array.from(xmlDoc.getElementsByTagName('Question'));

      const questions = questionsNodes.map((questionNode) => {
        const text = questionNode.getAttribute('Text');
        const answersNodes = Array.from(questionNode.getElementsByTagName('Answer'));

        const answers = answersNodes.map((answerNode) => ({
          label: answerNode.textContent,
          isSelected: answerNode.getAttribute('IsSelected') === 'true',
          xmlNode: answerNode // ✅ guardamos el nodo XML original
        }));

        return { text, answers };
      });

      this.setState({ questions, xmlDoc });
    }
  }

  resetResendFlag = () => {
    const countdown = c => c - 1;
    const interval = setInterval(() => {
      this.setState({ counter: countdown(this.state.counter) });
    }, 1000);
    this.timer = interval;
  };

  handleOTPCodes = prevProps => {
    const identityOTP = this.props.identityOTP;
    if (
      prevProps.identityOTP.usingCrosscoreParams !==
      identityOTP.usingCrosscoreParams &&
      !identityOTP.usingCrosscoreParams
    ) {
      this.getSecurityQuestions(false);
      return;
    }

    if (
      ['99', '6'].includes(identityOTP.OTPCode) ||
      (identityOTP.OTPCode === '1' && identityOTP.requiresQuestions)
    ) {
      this.props.resetOTPCodeProp();
      this.setState({ showOtpValidationModal: false });
      this.onSubmitGetSecurityQuestions(true)({
        name: this.props.identityOTP.name,
        lastName: this.props.identityOTP.lastName
      });
    } else if (identityOTP.OTPCode === '1') {
      this.props.resetOTPCodeProp();
      this.setState({ showOtpValidationModal: false });
    } else if (identityOTP.OTPCode === '4') {
      this.setState(
        {
          showOtpValidationModal: true,
          dataNeeded: false
        },
        this.props.resetOTPCodeProp
      );
    }

    // Verify OTP
    if (identityOTP.OTPCode === '2') {
      this.setState(
        { showOtpValidationModal: false },
        this.props.resetOTPCodeProp
      );
      this.props.newAlert(
        'error',
        'OTP No Aprobado',
        'El OTP ingresado no fue aprobado. Intente de nuevo o realice validación biométrica.'
      );
    }
  };

  handleCloseOtpModal = () => {
    this.setState({ showOtpValidationModal: false });
  };

  getSecurityQuestions = (withRegValidation = true) => {
    this.setState({ dataNeeded: false });
    if (
      !this.props.pointOfSales ||
      (this._isTraditionalSale() && this.ignoreBiometricValidation())
    ) {
      return;
    }
    const currentPOS = this.props.pointOfSales.find(i => i.id == this.props.pointOfSale);

    let params = {
      contractId: this.props.debtor.contract.toString(),
      identification: this.props.debtor.buyerID,
      identificationType: this.props.debtor.buyerIDType,
      expeditionDate: this.props.debtor.expeditionDate,
      currentClient: 'debtor',
      methodValidation: currentPOS.attributes.methodValidation,
      name: this.state.name,
      lastName: this.state.lastName,
      regValidation: withRegValidation
        ? this.props.identityOTP.regValidation
        : null
    };

    if (this.props.currentClient == 'cosigner') {
      params = {
        contractId: this.props.debtor.contract.toString(),
        identification: this.props.cosigner.cosignerID,
        identificationType: this.props.cosigner.cosignerIDType,
        expeditionDate: this.props.cosigner.expeditionDate,
        currentClient: 'cosigner',
        methodValidation: currentPOS.attributes.methodValidation,
        name: this.state.name,
        lastName: this.state.lastName,
        regValidation: withRegValidation
          ? this.props.identityOTP.regValidation
          : null
      };
    }

    params['usingCrosscoreParams'] = this._isTraditionalSale()
      ? false
      : this.props.identityOTP.usingCrosscoreParams;

    this.props.getSecurityQuestions(
      params,
      this.props.routes[this.nextStep],
      this.props.process
    );
  };

  handleChangeRadio1 = event => {
    this.setState({ value1: event.target.value });
  };

  handleChangeRadio2 = event => {
    this.setState({ value2: event.target.value });
  };

  handleChangeRadio3 = event => {
    this.setState({ value3: event.target.value });
  };

  handleChangeRadio4 = event => {
    this.setState({ value4: event.target.value });
  };

  ignoreBiometricValidation = () => {
    const {
      saleChannel,
      channelIgnoreBiometricsValidation,
      debtor,
      cosigner
    } = this.props;

    return (
      (saleChannel &&
        channelIgnoreBiometricsValidation &&
        channelIgnoreBiometricsValidation.some(item => item == saleChannel)) ||
      (debtor.buyerIDType == 'Cédula de Extranjería' ||
        (cosigner && cosigner.cosignerIDType == 'Cédula de Extranjería'))
    );
  };
  onSubmit = () => {
    const currentPOS = this.props.pointOfSales.find(i => i.id == this.props.pointOfSale);
    const params = {
      contractId: this.props.debtor.contract.toString(),
      idQuestionnaire:
        this.props.currentClient == 'debtor'
          ? this.props.debtorQuestions.idQuestionnaire
          : this.props.cosignerQuestions.idQuestionnaire,
      regQuestionnaire:
        this.props.currentClient == 'debtor'
          ? this.props.debtorQuestions.regQuestionnaire
          : this.props.cosignerQuestions.regQuestionnaire,
      identification:
        this.props.currentClient == 'debtor'
          ? this.props.debtor.buyerID
          : this.props.cosigner.cosignerID,
      identificationType:
        this.props.currentClient == 'debtor'
          ? this.props.debtor.buyerIDType
          : this.props.cosigner.cosignerIDType,
      securityAnswers: [
        { questionId: '1', idAnswer: this.state.value1.slice(1, 3) },
        { questionId: '2', idAnswer: this.state.value2.slice(1, 3) },
        { questionId: '3', idAnswer: this.state.value3.slice(1, 3) },
        { questionId: '4', idAnswer: this.state.value4.slice(1, 3) }
      ],
      expeditionDate:
        this.props.currentClient == 'debtor'
          ? this.props.debtor.expeditionDate
          : '',
      cosigner: this.props.cosigner.cosignerID,
      currentClient: this.props.currentClient,
      name: this.state.name,
      lastName: this.state.lastName,
      methodValidation: currentPOS.attributes.methodValidation,
      usingCrosscoreParams: this._isTraditionalSale()
        ? false
        : this.props.identityOTP.usingCrosscoreParams
    };

    this.props.checkSecurityAnswers(
      params,
      this.props.routes[this.nextStep],
      this.props.process
    );
    this.setState({ value1: 1, value2: 1, value3: 1, value4: 1 });
  };

  onSubmitDatacreditoQuery = values => {
    this.props.checkFourthStep(
      values,
      this.props.debtor,
      this.props.cosigner,
      {
        dcDebtorLastName: values.debtorLastName,
        dcCosignerLastName: values.cosignerLastName
      },
      this.props.routes[this.nextStep],
      this.props.process
    );
  };

  startOtpProcess = values => {
    this.setState({
      name: values.name,
      lastName: values.lastName,
      dataNeeded: false
    });

    const isOnCosignerValidation = this.props.currentClient == 'cosigner';

    const person = isOnCosignerValidation
      ? this.props.cosigner
      : this.props.debtor;

    const params = isOnCosignerValidation
      ? {
        contractId: this.props.debtor.contract.toString(),
        identification: person.cosignerID,
        identificationType: doctypes.find(o => o.name === person.cosignerIDType).id.toString(),
        name: values.name,
        lastName: values.lastName,
        expeditionDate: person.expeditionDate,
        email: values.email,
        mobile: `${values.mobile}`
      }
      : {
        contractId: this.props.debtor.contract.toString(),
        identification: person.buyerID,
        identificationType: doctypes.find(o => o.name === person.buyerIDType).id.toString(),
        name: values.name,
        lastName: values.lastName,
        expeditionDate: person.expeditionDate,
        email: values.email,
        mobile: `${values.mobile}`
      };

    this.setState({ email: '', mobile: '', mobileToValidate: values.mobile, emailToValidate: values.email });
    this.props.startOtpTransunion(params);
  };

  onSubmitGetSecurityQuestions = (withRegValidation = false) => values => {
    this.setState({ name: values.name, lastName: values.lastName });
    this.getSecurityQuestions(withRegValidation);
  };

  onSubmitCloseBiometricFail = (mandatoryBiometricValidation) => {
    this.setState({ biometricFailModal: false });
    if (!mandatoryBiometricValidation) {
      const currentPOS = this.props.pointOfSales && this.props.pointOfSales.find(i => i.id == this.props.pointOfSale);
      if (currentPOS.attributes.hasSecurityQuestions) this.setState({ dataNeeded: true });
    }
  };

  onSubmitBiometricValidation = (isDebtor, goNextStep) => {
    if (this.state.isSelectedFacialBiometric) {
      if (!this.props.canCheckFacialBiometricStatus) {
        this.props.newAlert(
          'error',
          'Validación Biométrica',
          'El usuario no cuenta con permisos para realizar esta validación.'
        );
        return;
      }

      this.props.checkFacialBiometricStatus(
        {
          contractId: this.props.debtor.contract.toString(),
          identification: this.state.biometric_identification,
          userId: this.props.userId,
          isDebtor,
          biometricLogId: isDebtor ? this.props.biometricLogId : this.props.cosignerBiometricLogid
        },
        this.props.routes[this.nextStep],
        this.props.process,
        goNextStep
      ).then(() => {
        if (this.props.debtor.biometricValidated && isDebtor && !goNextStep) {
          this.setState({ isSubmittingMobile: true, facialMobile: null });
        }
      });
    } else {
      this.props.checkBiometricValidation(
        {
          contractId: this.props.debtor.contract,
          identification: this.state.biometric_identification,
          biometricValidationFailedTimes: this.state.biometricValidationFailedTimes,
          pointOfSaleId: Number(this.props.pointOfSale)
        },
        this.props.routes[this.nextStep],
        this.props.process
      );
    }
  };

  onCloseDialog = () => {
    this.props.toggleIDModal(false);
    this.props.toggleModal(false);
  };

  //Se podria eliminar
  onContinue = () => {
    const INITIAL_STEP = 0;
    this.props.toggleIDModal(false);
    if (
      !['NO ENCONTRADO', 'VIGENTE', 'SUSPENDIDA'].includes(
        this.props.debtor.status
      )
    ) {
      this.props.toggleBaseErrorModal(
        true,
        'El documento de identificación del deudor no se encuentra vigente.',
        'Registraduría',
        this.props.routes[INITIAL_STEP]
      );
    } else if (
      this.props.cosigner.cosignerID &&
      !['NO ENCONTRADO', 'VIGENTE', 'SUSPENDIDA'].includes(
        this.props.cosigner.dcStatus
      )
    ) {
      this.props.toggleBaseErrorModal(
        true,
        'El documento de identificación del codeudor no se encuentra vigente.',
        'Registraduría',
        this.props.routes[INITIAL_STEP]
      );
    } else {
      this.props.setNextStep(this.props.process);
      if (
        this.props.debtor.status === 'NO ENCONTRADO' ||
        this.props.cosigner.dcStatus === 'NO ENCONTRADO'
      ) {
        this.props.toggleBaseErrorModal(
          true,
          'El sistema no tiene registro de uno o ninguno de los usuarios ingresados. El registro de venta continuará pero es necesario anexar un soporte que garantice la validez de los documentos de identificación ingresados en el proceso; de lo contrario la venta no podrá ser aprobada.',
          'Registraduría',
          this.props.routes[this.nextStep]
        );
      } else if (
        this.props.cosigner.cosignerID &&
        (this.props.debtor.status == 'FALLECIDO' ||
          this.props.cosigner.dcStatus === 'FALLECIDO')
      ) {
        this.props.toggleBaseErrorModal(
          true,
          'El documento de identificación de uno de los usuarios corresponde a una persona fallecida.',
          'Registraduría',
          this.props.routes[this.nextStep]
        );
      } else {
        this.props.history.push(this.props.routes[this.nextStep]);
      }
    }
  };

  addQuestionMark = question => {
    return question.includes('?') ? `¿${question}` : question;
  };

  _handleClose = () => {
    if (this.state.isSelectedSecurityQuestions) return;

    this.setState({ questionModal: false });
    this.props.toggleBaseErrorModal(false);
  };

  _handleCloseAdditionalData = () => {
    this.setState(
      {
        dataNeeded: false
      },
      this.props.resetProp({
        causal: false
      })
    );
  };

  _handleConfirm = setFieldValue => {
    this.props.chooseCausal(
      {
        contractId: this.props.debtor.contract,
        saleId: null,
        causalId: this.state.cause,
        debtorClientId: parseInt(this.props.debtor.buyerID),
        cosignerClientId: parseInt(this.props.cosigner.cosignerID)
      },
      this.props.routes[this.nextStep],
      this.props.process,
      setFieldValue
    ).then(isValid => {
      if (isValid) {
        this.setState({
          isSelectedFacialBiometric: false,
          isSelectedFingerprintBiometric: false,
          isSelectedSecurityQuestions: true,
          questionModal: false
        });
      }
    });
  };

  _handleSelectChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  _isRemoteDigitalSale = () => {
    return (
      this.props.process === 'remoteDigitalSaleWithUUP' ||
      this.props.process === 'remoteDigitalSaleWithoutUUP'
    );
  };

  _isTraditionalSale = () => {
    return this.props.process === 'portal';
  };

  renderCausals() {
    const {
      classes,
      isSecureSale,
      isBiometricValidationInSecureSaleActive,
      enableBiometricValidationWithCosigner,
      enableBiometricValidationForSalesWithCosigner,
      isCosigner
    } = this.props;
    const { questionModal } = this.state;
    const initialValuesCause = {
      cause: '',
      description: ''
    };

    const mandatoryBiometricValidation =
      isSecureSale && isBiometricValidationInSecureSaleActive;
    const saleType = toCamelCase(window.location.pathname.split('/')[1]);
    const biometricValidationWithCosigner =
      enableBiometricValidationWithCosigner &&
      enableBiometricValidationForSalesWithCosigner[saleType] &&
      isCosigner;

    const biometricValidation =
      mandatoryBiometricValidation || biometricValidationWithCosigner;
    const biometricValidationMessage = mandatoryBiometricValidation
      ? 'Las preguntas reto no se encuentran disponibles en una venta con fianza'
      : 'Este tipo de venta solo se puede realizar por validación biométrica.';

    return (
      <Formik
        initialValues={initialValuesCause}
        validationSchema={validationSchemaCause}
        render={({ values, errors, touched, handleChange, setFieldValue }) => (
          <CustomDialog
            open={questionModal}
            disableBackdropClick={true}
            onClose={this._handleClose}
            onConfirm={() =>
              !biometricValidation
                ? this._handleConfirm(setFieldValue)
                : this._handleClose()
            }
            title={
              !biometricValidation
                ? `Pasar a otro método de validación`
                : `Mensaje importante`
            }
            contentText={
              !biometricValidation
                ? `Para poder pasar a otro método de validación, debe escoger un causal. Además, si lo desea, podrá añadir una observación.`
                : ''
            }
            buttonText={'CONTINUAR'}
          >
            {!biometricValidation ? (
              <Form className={classes.formCause}>
                <Grid container>
                  <Fade in={true}>
                    <Grid item xs={12}>
                      <OutlinedSelectChippedInput
                        label="Causal:"
                        required
                        name="cause"
                        options={this.props.securityQuestionsCausals.map(
                          causal => ({
                            value: causal.id,
                            title: causal.description
                          })
                        )}
                        value={this.state.cause || values.cause}
                        onChange={e => {
                          handleChange(e);
                          this._handleSelectChange(e);
                        }}
                        withChip={false}
                        error={touched.cause && !!errors.cause}
                        helperText={touched.cause && errors.cause}
                        fullWidth
                        margin="normal"
                        variant="outlined"
                      />
                    </Grid>
                  </Fade>
                  <Grid item xs={12}>
                    <TextField
                      label="Observación:"
                      name="observation"
                      margin="normal"
                      variant="outlined"
                      onChange={e => {
                        handleChange(e);
                        this._handleSelectChange(e);
                      }}
                      inputProps={{ maxLength: 200 }}
                      value={this.state.observation || values.description}
                      fullWidth
                      multiline
                    />
                    <p className={classes.observation}>{`${this.state.observation.length
                      } / 200`}</p>
                  </Grid>
                </Grid>
              </Form>
            ) : (
              <p>{biometricValidationMessage}</p>
            )}
          </CustomDialog>
        )}
      />
    );
  }

  sendFacialBiometricMessage(identification, mobile, isDebtor = false, contractId) {
    if (!this.props.canSendFacialBiometricMessage) {
      this.props.newAlert(
        'error',
        'Validación Biométrica',
        'El usuario no cuenta con permisos para envío de mensajes de texto.'
      );
      return;
    }

    if (this.state.counter > 0 || this.props.stepIsLoading) return;

    if (mobile === '' || mobile.length !== 10) {
      this.props.newAlert(
        'error',
        'Validación Biométrica',
        'El número de celular no es válido'
      );
      return;
    }

    this.props.sendFacialBiometricMessage({ identification, mobile, isDebtor, contractId }).then(() => {
      this.setState({ isSubmittingMobile: false });
      setTimeout(() => {
        clearInterval(this.timer);
        this.setState({ counter: this.RESEND_FLAG_SECONDS_DELAY, canResend: false });
        this.resetResendFlag();
      }, 1000);
    });
  }

  handleSelectAnswer = (questionIndex, answerIndex) => {
    const questions = [...this.state.questions];

    questions[questionIndex].answers.forEach((ans, i) => {
      ans.isSelected = i === answerIndex;
      ans.xmlNode.setAttribute("IsSelected", i === answerIndex ? "true" : "false");
    });

    this.setState({ questions });
  };

  checkSecurityAnswers = () => {
    const serializer = new XMLSerializer();
    const isCosigner = this.props.currentClient === 'cosigner';
    const person = isCosigner ? this.props.cosigner : this.props.debtor;

    this.props.checkSecurityAnswersTransunion(
      {
        applicationId: this.props.applicationId.toString(),
        examData: serializer.serializeToString(this.state.xmlDoc),
        currentClient: this.props.currentClient,
        contractId: this.props.debtor.contract.toString(),
        hasCosigner: this.props.cosigner.cosignerID !== '',
        identification: isCosigner ? person.cosignerID : person.buyerID,
      },
      this.props.routes[this.nextStep],
      this.props.process
    );
  };

  areAllQuestionsAnswered = () => {
    return this.state.questions.every((question) =>
      question.answers.some((answer) => answer.isSelected)
    );
  };

  // eslint-disable-next-line complexity
  render() {
    const {
      classes,
      debtor,
      cosigner,
      debtorServerErrors = {},
      cosignerServerErrors = {},
      loading,
      idModal,
      promissory,
      transfer,
      cosignerIdentification,
      pointOfSale,
      pointOfSales,
      isSecureSale,
      isBiometricValidationInSecureSaleActive,
      identityOTP,
      currentClient,
      process,
      routes,
      stepIsLoading,
      applicationId,
      otpSent,
      examData,
      isGeneralWarrantySale,
      debtorMandatoryValidations = {},
      cosignerMandatoryValidations = {}
    } = this.props;

    const {
      facialMobile,
      isSelectedFacialBiometric,
      isSelectedSecurityQuestions,
      isSelectedFingerprintBiometric,
      isSubmittingMobile
    } = this.state;

    const mandatoryBiometricValidation = isSecureSale && isBiometricValidationInSecureSaleActive;
    const currentPOS = pointOfSales && pointOfSales.find(i => i.id == pointOfSale);
    const biometricValidationURL = currentPOS && currentPOS.attributes.biometricApiUrl;

    if (
      (!this._isTraditionalSale() || !this.ignoreBiometricValidation() || mandatoryBiometricValidation) &&
      biometricValidationURL &&
      !this.state.externalTabOpened &&
      isSelectedFingerprintBiometric
    ) {
      window.open(biometricValidationURL, '_blank');
      this.setState({ externalTabOpened: true });
    }

    const initialValues = {
      debtorLastName: debtor.dcDebtorLastName || '',
      debtorDocType: debtor.buyerIDType,
      debtorID: debtor.buyerID,
      cosignerLastName: transfer.contract ? '' : cosigner.cosignerID ? cosigner.dcCosignerLastName || '' : '',
      cosignerDocType: transfer.identificationType || cosigner.cosignerIDType,
      cosignerID: transfer.identification || cosigner.cosignerID
    };

    const initialValuesAdditionData = {
      lastName:
        this.props.currentClient == 'debtor'
          ? debtor.securityQuestionsLastName
            ? debtor.securityQuestionsLastName
            : ''
          : cosigner.securityQuestionsLastName
            ? cosigner.securityQuestionsLastName
            : '',
      name:
        this.props.currentClient == 'debtor'
          ? debtor.securityQuestionsName
            ? debtor.securityQuestionsName
            : ''
          : cosigner.securityQuestionsName
            ? cosigner.securityQuestionsName
            : '',
      email: '',
      mobile: ''
    };
    const isOnDebtorValidation = !debtor.biometricValidated || ((!promissory || !promissory.cosigner) && !initialValues.cosignerID);

    if (isOnDebtorValidation) {
      this.setState({ biometric_identification: debtor.buyerID });
    } else {
      this.setState({ biometric_identification: initialValues.cosignerID });
    }

    const biometricEnabled = currentPOS && (isSelectedFingerprintBiometric || isSelectedFacialBiometric) || mandatoryBiometricValidation;

    let allowChangeToQuestions = !isGeneralWarrantySale;

    const mandatoryValidation = Object.keys(ValidationMethodTypes)
      .map(_lowerFirst)
      .find(method => debtorMandatoryValidations[method] === 1 || cosignerMandatoryValidations[method] === 1);

    if (mandatoryValidation) {
      const validationName = ValidationMethodTypes[_upperFirst(mandatoryValidation)];
      allowChangeToQuestions = validationName === ValidationMethodTypes.SecurityQuestions;
    }

    return (
      <div>
        <Paper className={classes.container}>
          {(!this._isTraditionalSale() || !this.ignoreBiometricValidation()) &&
            currentPOS && (currentPOS.attributes.hasSecurityQuestions || biometricEnabled) || mandatoryBiometricValidation ? (
            <>
              {(isSelectedSecurityQuestions || this.state.securityForm) && !mandatoryBiometricValidation && (
                <Form className={classes.form}>
                  <>
                    {this.renderCausals()}
                    <SegmentHeader className={classes.segmentHeader}>
                      PREGUNTAS DE SEGURIDAD{' '}
                      {this.props.currentClient == 'cosigner' ? 'CODEUDOR - ' : 'DEUDOR - '}
                      {this.state.name} {this.state.lastName}
                    </SegmentHeader>
                    <Grid container spacing={24} alignItems="flex-start">
                      <div style={{ padding: '12px', width: '100%' }}>
                        {examData && (
                          <>
                            {this.state.questions.map((question, qIndex) => (
                              <div key={question.id}>

                                <FormItemContainer
                                  title={question.text.toUpperCase()}
                                  classes={{ container: classes.container }}
                                  mediumSize={true}
                                >
                                  <FormControl component="fieldset">
                                    <RadioGroup
                                      aria-label="gender"
                                      name={`question-${qIndex}`}
                                    >
                                      {question.answers.map((answer, aIndex) => (
                                        <FormControlLabel
                                          value={aIndex.toString()}
                                          control={<Radio checked={answer.isSelected} />}
                                          label={answer.label.toUpperCase()}
                                          key={aIndex}
                                          onChange={() => this.handleSelectAnswer(qIndex, aIndex)}
                                        />
                                      )
                                      )}
                                    </RadioGroup>
                                  </FormControl>
                                </FormItemContainer>
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                    </Grid>
                  </>
                  <StepperButtons
                    disabledNext={!examData || !this.areAllQuestionsAnswered()}
                    onSubmit={this.checkSecurityAnswers}
                    customLoading={loading}
                    goBack={this.props.goBack}
                  />
                </Form>
              )}
              {biometricEnabled && !this.state.securityForm && (
                <>
                  {isOnDebtorValidation ? (
                    <Fragment>
                      {isSelectedFacialBiometric && isSubmittingMobile ? (
                        <CustomDialog
                          open={isSubmittingMobile}
                          disableBackdropClick={true}
                          onConfirm={() => this.sendFacialBiometricMessage(debtor.buyerID, facialMobile, true, this.props.debtor.contract)}
                          title={`Mensaje importante: Validación biométrica`}
                          buttonText={'CONTINUAR'}
                          loading={stepIsLoading}
                        >
                          <p>
                            Ingrese el número de celular del deudor para continuar:
                          </p>
                          <OutlinedTextField
                            name="facialMobile"
                            label="Celular del deudor:"
                            value={facialMobile}
                            error={facialMobile !== null && facialMobile === ''}
                            helperText={facialMobile !== null && facialMobile === '' ? 'El teléfono es obligatorio' : ''}
                            onChange={e => this.setState({ facialMobile: e.target.value.replace(/\D/g, '').slice(0, 10) })}
                          />
                        </CustomDialog>
                      ) : (
                        <>
                          <div className={classes.segmentHeaderOptions}>
                            <SegmentHeader className={classes.segmentHeader}>
                              VALIDACIÓN BIOMÉTRICA DEUDOR - {debtor.buyerID}
                            </SegmentHeader>
                            {currentPOS.attributes.hasSecurityQuestions && allowChangeToQuestions && (
                              <PrimaryButton
                                onClick={() => {
                                  this.setState({ questionModal: true });
                                }}
                                className={classes.button}
                              >
                                Pasar a otro método de validación
                              </PrimaryButton>
                            )}
                          </div>
                          {this.renderCausals()}
                          <div className={classes.item} variant="caption">
                            {`El proceso de validación biométrica está siendo realizado por el usuario en este momento. Al
                              completar el proceso, favor continuar presionando `}
                            <span className={classes.headline}>
                              <a
                                className={classes.linkRef}
                                href={biometricValidationURL}
                                // eslint-disable-next-line react/jsx-no-target-blank
                                target="_blank"
                              >
                                Siguiente
                              </a>
                            </span>
                            {` en esta pantalla`}
                          </div>
                          {isSelectedFacialBiometric && <div className={classes.actionContainer}>
                            <span
                              id="PhoneVerificationDialog_span_resendVerification"
                              onClick={() => this.sendFacialBiometricMessage(debtor.buyerID, facialMobile, true, this.props.debtor.contract)}
                              className={this.state.counter ? {} : classes.pointer}
                            >
                              <Timer counter={this.state.counter} loading={loading} message="Reenviar mensaje" />
                            </span>
                          </div>}
                          <StepperButtons
                            disabledNext={mandatoryBiometricValidation && this.state.noTriesRemaining}
                            onSubmit={() => this.onSubmitBiometricValidation(true, !initialValues.cosignerID)}
                            customLoading={loading}
                            goBack={this.props.goBack}
                          />
                        </>
                      )}
                    </Fragment>
                  ) : (
                    <Fragment>
                      {isSelectedFacialBiometric && isSubmittingMobile ? (
                        <CustomDialog
                          open={isSubmittingMobile}
                          disableBackdropClick={true}
                          onConfirm={() => this.sendFacialBiometricMessage(cosigner.cosignerID, facialMobile, false, this.props.debtor.contract)}
                          title={`Mensaje importante: Validación biométrica`}
                          buttonText={'CONTINUAR'}
                          loading={stepIsLoading}
                        >
                          <p>
                            Ingrese el número de celular del codeudor para continuar:
                          </p>
                          <OutlinedTextField
                            name="facialMobile"
                            label="Celular del codeudor:"
                            value={facialMobile}
                            error={facialMobile !== null && facialMobile === ''}
                            helperText={facialMobile !== null && facialMobile === '' ? 'El teléfono es obligatorio' : ''}
                            onChange={e => this.setState({ facialMobile: e.target.value.replace(/\D/g, '').slice(0, 10) })}
                          />
                        </CustomDialog>
                      ) : (
                        <>
                          <div className={classes.segmentHeaderOptions}>
                            <SegmentHeader className={classes.segmentHeader}>
                              VALIDACIÓN BIOMÉTRICA CODEUDOR - {cosigner.cosignerID}
                            </SegmentHeader>
                          </div>
                          <div className={classes.item} variant="caption">
                            {`El proceso de validación biométrica está siendo realizado por el usuario en este momento. Al
                        completar el proceso, favor continuar presionando `}
                            <span className={classes.headline}>Siguiente</span>
                            {` en esta pantalla`}
                          </div>
                          {isSelectedFacialBiometric && <div className={classes.actionContainer}>
                            <span
                              id="PhoneVerificationDialog_span_resendVerification"
                              onClick={() => this.sendFacialBiometricMessage(cosigner.cosignerID, facialMobile, false, this.props.debtor.contract)}
                              className={this.state.counter ? {} : classes.pointer}
                            >
                              <Timer counter={this.state.counter} loading={loading} message="Reenviar mensaje" />
                            </span>
                          </div>}
                          <StepperButtons
                            onSubmit={() => this.onSubmitBiometricValidation(false, true)}
                            customLoading={loading}
                            goBack={this.props.goBack}
                          />
                        </>
                      )}
                    </Fragment>
                  )
                  }
                </>
              )}
            </>
          ) : (
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema(!!cosignerIdentification)}
              onSubmit={this.onSubmitDatacreditoQuery}
              render={({
                values,
                errors,
                handleChange,
                handleSubmit,
                touched
              }) => (
                <Form className={classes.form}>
                  <SegmentHeader
                    className={`${classes.segmentHeader} ${classes.segmentHeaderMargin}`}
                  >
                    VALIDACIÓN REGISTRADURIA DEUDOR
                  </SegmentHeader>
                  <Grid container spacing={24} alignItems="flex-start">
                    <Grid
                      item
                      md={4}
                      sm={6}
                      xs={12}
                      className={classes.gridItem}
                    >
                      <OutlinedTextField
                        name="debtorLastName"
                        label="Primer apellido del deudor:"
                        value={values.debtorLastName}
                        error={
                          !!debtorServerErrors.debtorLastName ||
                          (touched.debtorLastName && !!errors.debtorLastName)
                        }
                        helperText={
                          debtorServerErrors.debtorLastName ||
                          (touched.debtorLastName && errors.debtorLastName)
                        }
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid
                      item
                      md={4}
                      sm={6}
                      xs={12}
                      className={classes.gridItem}
                    >
                      <OutlinedTextField
                        label="Tipo Identificación del deudor:"
                        value={values.debtorDocType}
                        disabled
                      />
                    </Grid>
                    <Grid
                      item
                      md={4}
                      sm={6}
                      xs={12}
                      className={classes.gridItem}
                    >
                      <OutlinedTextField
                        label="Identificación del deudor:"
                        value={values.debtorID}
                        disabled
                      />
                    </Grid>
                  </Grid>
                  {((promissory && promissory.cosigner) ||
                    values.cosignerID) && (
                      <Fragment>
                        <SegmentHeader
                          className={`${classes.segmentHeader} ${classes.segmentHeaderMargin}`}
                        >
                          VALIDACIÓN REGISTRADURIA CODEUDOR
                        </SegmentHeader>
                        <Grid container spacing={24} alignItems="flex-start">
                          <Grid
                            item
                            md={4}
                            sm={6}
                            xs={12}
                            className={classes.gridItem}
                          >
                            <OutlinedTextField
                              name="cosignerLastName"
                              label="Primer apellido del codeudor:"
                              value={values.cosignerLastName}
                              error={
                                !!cosignerServerErrors.cosignerLastName ||
                                (touched.cosignerLastName &&
                                  !!errors.cosignerLastName)
                              }
                              helperText={
                                cosignerServerErrors.cosignerLastName ||
                                (touched.cosignerLastName &&
                                  errors.cosignerLastName)
                              }
                              onChange={handleChange}
                            />
                          </Grid>
                          <Grid
                            item
                            md={4}
                            sm={6}
                            xs={12}
                            className={classes.gridItem}
                          >
                            <OutlinedTextField
                              label="Tipo Identificación del codeudor:"
                              value={values.cosignerDocType}
                              disabled
                            />
                          </Grid>
                          <Grid
                            item
                            md={4}
                            sm={6}
                            xs={12}
                            className={classes.gridItem}
                          >
                            <OutlinedTextField
                              label="Identificación del codeudor:"
                              value={values.cosignerID}
                              disabled
                            />
                          </Grid>
                        </Grid>
                      </Fragment>
                    )}
                  <StepperButtons
                    onSubmit={handleSubmit}
                    customLoading={loading}
                    goBack={this.props.goBack}
                  />
                </Form>
              )}
            />
          )}
        </Paper>
        {idModal && (
          <Dialog
            onClose={this.onCloseDialog}
            open={idModal}
            PaperProps={{
              className: cosigner.cosignerID
                ? classes.dialogWithCosigner
                : classes.dialog
            }}
          >
            <MuiDialogContent>
              <article className={classes.dataContainer}>
                <section
                  className={
                    cosigner.cosignerID
                      ? classes.debtorDataWithCosigner
                      : classes.debtorData
                  }
                >
                  <MuiDialogTitle>Deudor</MuiDialogTitle>
                  <InfoField label="TIPO DE IDENTIFICACION:">
                    {debtor && debtor.buyerIDType}
                  </InfoField>
                  <InfoField label="NUMERO:">
                    {debtor && debtor.docID.replace(/^0+/, '')}
                  </InfoField>
                  {debtor.buyerIDType != 'Cédula de Extranjería' && (
                    <InfoField label="DEPARTAMENTO:">
                      {debtor && debtor.department}
                    </InfoField>
                  )}
                  {debtor.buyerIDType != 'Cédula de Extranjería' && (
                    <InfoField label="CIUDAD:">
                      {debtor && debtor.locality}
                    </InfoField>
                  )}
                  {debtor.buyerIDType == 'Cédula de Extranjería' && (
                    <InfoField label="PAIS ORIGEN:">
                      {debtor && debtor.country}
                    </InfoField>
                  )}
                  <InfoField label="NOMBRE:">{debtor && debtor.name}</InfoField>
                  <InfoField label="PRIMER APELLIDO:">
                    {debtor && debtor.lastName}
                  </InfoField>
                  <InfoField label="SEGUNDO APELLIDO:">
                    {debtor && debtor.secondLastName}
                  </InfoField>
                  <InfoField label="GENERO:">{debtor.gender || '--'}</InfoField>
                  <InfoField label="FECHA EXPEDICION:">
                    {debtor && debtor.expeditionDate}
                  </InfoField>
                  <InfoField label="ESTADO:">{debtor.status || '--'}</InfoField>
                </section>
                {cosigner.cosignerID && (
                  <section className={classes.cosignerData}>
                    <MuiDialogTitle>Codeudor</MuiDialogTitle>
                    <InfoField label="TIPO DE IDENTIFICACION:">
                      {cosigner && cosigner.cosignerIDType}
                    </InfoField>
                    <InfoField label="NUMERO:">
                      {cosigner && cosigner.dcID.replace(/^0+/, '')}
                    </InfoField>
                    {cosigner.cosignerIDType != 'Cédula de Extranjería' && (
                      <InfoField label="DEPARTAMENTO:">
                        {cosigner && cosigner.dcDepartment}
                      </InfoField>
                    )}
                    {cosigner.cosignerIDType != 'Cédula de Extranjería' && (
                      <InfoField label="CIUDAD:">
                        {cosigner && cosigner.dcLocality}
                      </InfoField>
                    )}
                    {cosigner.cosignerIDType == 'Cédula de Extranjería' && (
                      <InfoField label="PAIS ORIGEN:">
                        {cosigner && cosigner.dcCountry}
                      </InfoField>
                    )}
                    <InfoField label="NOMBRE:">
                      {cosigner && cosigner.dcName}
                    </InfoField>
                    <InfoField label="PRIMER APELLIDO:">
                      {cosigner && cosigner.dcLastName}
                    </InfoField>
                    <InfoField label="SEGUNDO APELLIDO:">
                      {cosigner && cosigner.dcSecondLastName}
                    </InfoField>
                    <InfoField label="GENERO:">
                      {cosigner.dcGender || '--'}
                    </InfoField>
                    <InfoField label="FECHA EXPEDICION:">
                      {cosigner && cosigner.dcExpeditionDate}
                    </InfoField>
                    <InfoField label="ESTADO:">
                      {cosigner.dcStatus || '--'}
                    </InfoField>
                  </section>
                )}
              </article>
            </MuiDialogContent>
            <MuiDialogActions>
              <PrimaryButton
                className={classes.dialogButton}
                onClick={this.onContinue}
              >
                CONTINUAR
              </PrimaryButton>
            </MuiDialogActions>
          </Dialog>
        )}
        {this.state.dataNeeded && (
          <Formik
            initialValues={initialValuesAdditionData}
            validationSchema={validationSchemaAdditionalDataOTP()}
            onSubmit={this.startOtpProcess}
            render={({
              values,
              errors,
              handleChange,
              handleSubmit,
              touched
            }) => (
              <CustomDialog
                open={this.state.dataNeeded}
                disableBackdropClick={true}
                onClose={this._handleCloseAdditionalData}
                onConfirm={handleSubmit}
                title={`Se requiere la siguiente información`}
                buttonText={'CONTINUAR'}
              >
                <Form className={classes.formAdditionalData}>
                  <SegmentHeader
                    className={`${classes.segmentHeader} ${classes.segmentHeaderMargin}`}
                  >
                    INFORMACIÓN{' '}
                    {this.props.currentClient == 'debtor'
                      ? 'DEUDOR'
                      : 'CODEUDOR'}
                  </SegmentHeader>
                  <Grid container spacing={24} alignItems="flex-start">
                    <Grid
                      item
                      md={6}
                      sm={6}
                      xs={12}
                      className={classes.gridItem}
                    >
                      <OutlinedTextField
                        name="lastName"
                        label={
                          'Primer apellido del ' +
                          (this.props.currentClient == 'debtor'
                            ? 'deudor'
                            : 'codeudor') +
                          ':'
                        }
                        value={values.lastName}
                        error={
                          Boolean(debtorServerErrors.debtorLastName) ||
                          Boolean(cosignerServerErrors.cosignerLastName) ||
                          (touched.lastName && !!errors.lastName)
                        }
                        helperText={
                          Boolean(debtorServerErrors.debtorLastName) ||
                          Boolean(cosignerServerErrors.cosignerLastName) ||
                          (touched.lastName && errors.lastName)
                        }
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid
                      item
                      md={6}
                      sm={6}
                      xs={12}
                      className={classes.gridItem}
                    >
                      <OutlinedTextField
                        name="name"
                        label={
                          'Nombres del ' +
                          (this.props.currentClient == 'debtor'
                            ? 'deudor'
                            : 'codeudor') +
                          ':'
                        }
                        value={values.name}
                        error={
                          Boolean(debtorServerErrors.name) ||
                          Boolean(cosignerServerErrors.name) ||
                          (touched.name && !!errors.name)
                        }
                        helperText={
                          Boolean(debtorServerErrors.name) ||
                          Boolean(cosignerServerErrors.name) ||
                          (touched.name && errors.name)
                        }
                        onChange={handleChange}
                      />
                    </Grid>
                  </Grid>
                  <div>
                    <SegmentHeader
                      className={`${classes.segmentHeader} ${classes.segmentHeaderMargin}`}
                    >
                      INFORMACIÓN DE CONTACTO
                    </SegmentHeader>
                    <Grid container>
                      <Grid item xs={12}>
                        <TextField
                          label="Correo Electrónico:"
                          name="email"
                          margin="normal"
                          variant="outlined"
                          onChange={e => {
                            handleChange(e);
                            this._handleSelectChange(e);
                          }}
                          value={this.state.email}
                          error={touched.email && !!errors.email}
                          helperText={touched.email && errors.email}
                          required
                          fullWidth
                        />

                        <TextField
                          label="Teléfono Celular:"
                          name="mobile"
                          margin="normal"
                          variant="outlined"
                          onChange={e => {
                            handleChange(e);
                            this._handleSelectChange(e);
                          }}
                          value={this.state.mobile}
                          error={touched.mobile && !!errors.mobile}
                          helperText={touched.mobile && errors.mobile}
                          type={'number'}
                          onInput={e => {
                            e.target.value = Math.max(
                              0,
                              parseInt(e.target.value)
                            )
                              .toString()
                              .slice(0, 10);
                          }}
                          required
                          fullWidth
                        />
                      </Grid>
                    </Grid>
                  </div>
                </Form>
              </CustomDialog>
            )}
          />
        )}
        {this.state.biometricFailModal && (
          <Formik
            onSubmit={() => this.onSubmitCloseBiometricFail(mandatoryBiometricValidation)}
            render={({
              handleSubmit,
            }) => (
              <CustomDialog
                open={this.state.biometricFailModal}
                disableBackdropClick={true}
                onConfirm={handleSubmit}
                title={`Mensaje importante: Validación biométrica`}
                buttonText={'CONTINUAR'}
              >
                <p className={classes.biometricErrorModal}>
                  {mandatoryBiometricValidation ? "Se agotaron los intentos. No se puede continuar con la venta" : this.props.biometricError}
                </p>
              </CustomDialog>
            )}
          />
        )}
        <OTPValidationProcess
          open={this.state.showOtpValidationModal}
          identityOTP={identityOTP}
          email={this.props.identityOTP.email}
          mobile={this.props.identityOTP.mobile}
          identification={
            this.props.currentClient == 'cosigner'
              ? cosigner.cosignerID
              : debtor.buyerID
          }
          identificationType={
            this.props.currentClient == 'cosigner'
              ? cosigner.cosignerIDType
              : debtor.buyerIDType
          }
          currentClient={currentClient}
          cosigner={cosigner.cosignerID}
          route={routes[this.nextStep]}
          process={process}
          contractId={this.props.debtor.contract}
          verifyIdentityOtp={this.props.verifyIdentityOtp}
          handleCloseOtpModal={this.handleCloseOtpModal}
          classes={classes}
        />
        <OTPTransunionModal
          open={otpSent}
          mobile={this.state.mobileToValidate}
          email={this.state.emailToValidate}
          applicationId={applicationId}
          selectedMethod={this.props.selectedMethod}
          verifyOtpTransunion={this.props.verifyOtpTransunion}
          getSecurityQuestionsTransunion={this.props.getSecurityQuestionsTransunion}
          resendOtpTransunion={this.props.resendOtpTransunion}
          route={routes[this.nextStep]}
          process={process}
          loading={this.props.stepIsLoading}
          currentClient={this.props.currentClient}
          contractId={this.props.debtor.contract.toString()}
          hasCosigner={this.props.cosigner.cosignerID !== ''}
          identification={this.props.currentClient === 'debtor' ? debtor.buyerID : cosigner.cosignerID}
          timeRemaining={this.props.timeRemaining || Date.now() + 2 * 60 * 1000}
        />
        <CustomDialog
          open={this.state.showAniUnavailableModal && !biometricEnabled}
          title={`No se puede continuar con la venta`}
          onClose={() => this.setState({ showAniUnavailableModal: false })}
          onConfirm={() => this.setState({ showAniUnavailableModal: false })}
          disableBackdropClick={false}
          buttonText={'Cerrar'}
        >
          <Typography variant="body1">
            El servicio de validación de vigencia de cédula no se encuentra
            disponible, por lo tanto no es posible continuar con la validación
            de identidad
          </Typography>
        </CustomDialog>
      </div>
    );
  }
}
const styles = theme => ({
  container: {},
  segmentHeaderOptions: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#f5f5f5'
  },
  button: {
    margin: 2,
    padding: '8px'
  },
  segmentHeader: {
    marginTop: 3 * theme.spacing.unit,
    '&:first-of-type': {
      marginTop: 2
    }
  },
  segmentHeaderMargin: {
    marginBottom: 2 * theme.spacing.unit
  },
  gridItem: {
    paddingTop: '0 !important',
    paddingBottom: '12 !important'
  },
  table: {
    marginTop: 3 * theme.spacing.unit,
    marginBottom: 3 * theme.spacing.unit
  },
  actionBar: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  form: {
    display: 'flex',
    flexDirection: 'column'
  },
  formCause: {
    padding: '8px'
  },
  observation: {
    color: 'grey',
    fontSize: '.9em',
    margin: 0,
    padding: 0
  },
  mainButton: {
    alignSelf: 'flex-end',
    marginTop: 4 * theme.spacing.unit,
    paddingLeft: 8 * theme.spacing.unit,
    paddingRight: 8 * theme.spacing.unit
  },
  registerDateContainer: {
    marginTop: theme.spacing.unit,
    marginBottom: 2 * theme.spacing.unit
  },
  dialog: {
    width: '100%'
  },
  dialogWithCosigner: {
    width: '100%',
    maxWidth: 1200
  },
  dialogButton: {
    margin: 1 * theme.spacing.unit,
    marginTop: 0,
    paddingLeft: 8 * theme.spacing.unit,
    paddingRight: 8 * theme.spacing.unit
  },
  dataContainer: {
    display: 'flex',
    flexDirection: 'row'
  },
  debtorData: {
    flex: '100%'
  },
  debtorDataWithCosigner: {
    flex: '50%',
    borderRight: '1px solid black'
  },
  cosignerData: {
    flex: '50%'
  },
  item: {
    margin: 20,
    textAlign: 'center'
  },
  headline: {
    color: theme.palette.secondary.main,
    fontWeight: 'bold'
  },
  formAdditionalData: {
    padding: 0
  },
  biometricErrorModal: {
    minHeight: '100px'
  },
  linkRef: {
    textDecoration: 'none',
    color: 'inherit'
  },
  pointer: {
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  actionContainer: {
    textAlign: 'center',
    width: '100%',
    marginTop: 24,
    marginBottom: 24,
    fontSize: '22px',
  },
});

PortalIDCheck.propTypes = {
  classes: PropTypes.object.isRequired,
  debtor: PropTypes.object,
  history: PropTypes.object.isRequired,
  validateInformation: PropTypes.func.isRequired
};

export default withStyles(styles)(PortalIDCheck);
